import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    header: {
        /** Header title for the workspaces section */
        title: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Text labels for the workspaces navigation header */
            header: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Header title for the workspaces section */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Workspaces_Header.header.title?c=2qdcenpfm5ojs", defaultMessage: "Workspaces" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
